import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class UploadData {
  constructor () {
    instance = instance || this

    this._table = DB.uploadData

    return instance
  }

  /**
   * @param [number] options.uploadDeviceId
   * @param [number] options.deviceId
   * @param [number] options.dataId
   * @param [string] options.iName
   * @param [string] options.iId
   * @param [string] options.iUnit
   * @param [string] options.iCode
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      uploadDeviceId: options.uploadDeviceId,
      deviceId: options.deviceId,
      dataId: options.dataId,
      iName: options.iName,
      iId: options.iId,
      iUnit: options.iUnit,
      iCode: options.iCode
    })
  }

  async get (id) {
    return this._table.get(id)
  }

  async update (id, options) {
    return this._table.update(id, options)
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async all () {
    return this._table.toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/upload-data.js